module.exports = __webpack_public_path__ + "img/ssl.0a79e60c.png";